<template>
  <div class="m--skin-login" style="height: 100%">
    <header>
      <div class="m-header__top t3-header"></div>
    </header>
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2"
        id="m_login">
        <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
          <div class="m-login__container">
            <div class="m-login__forget-password" style="display: block">
              <div class="m-login__head">
                <h3 class="m-login__title">
                  Forgotten Password ?
                </h3>
                <div class="m-login__desc">
                  Enter your details to Request:
                </div>
              </div>
              <div class="m-login__form m-form" :class="{'has-danger': errors.has('idNo') }">
                <div class="form-group m-form__group">
                  <p class="m--margin-top-20">Send instructions to?</p>
                  <label class="m-radio m--margin-right-10">
                    <input type="radio" v-model="medium" value="phoneNo"> Phone Number
                    <span></span>
                  </label>
                  <label class="m-radio">
                    <input type="radio" v-model="medium" value="email"> Email
                    <span></span>
                  </label>
                </div>
                <div class="form-group m-form__group m--margin-top-20">
                  <input type="text" class="form-control m-input" id="idNo" name="idNo" v-validate="'required'"
                         data-vv-as="ID number" v-model="idNo" placeholder="Your ID Number">
                  <small v-show="errors.has('idNo')" class="form-control-feedback">{{ errors.first('idNo') }}</small>
                </div>
                <div class="m-login__form-action">
                  <button @click="passwordResetRequest"
                          class="btn btn-custome-login btn-block m-btn- m-btn--custom m-btn--air m-login__btn m-login__btn--custome" v-text="loading">
                  </button>

                </div>
                <div class="m-login__account m--margin-top-20">
                  <span class="m-login__account-msg">Back to</span>&nbsp;&nbsp;
                  <router-link to="/" id="m_login_signup" class="m-link m-link--light m-login__account-link">
                    log in
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../api";
  import helper from "../../helpers";
  import Welcome from "../partials/Welcome";

  export default {
    name: "forgot-password",
    data() {
      return {
        idNo: "",
        medium: "phoneNo",
        loading: "Request"
      };
    },
    components: {
      welcome: Welcome
    },
    methods: {
      passwordResetRequest() {
        this.$validator
          .validate("idNo", this.idNo)
          .then(valid => {
            if (valid) {
              let {idNo, medium} = this;
              const txtType = "reset-password";
              this.loading = "Loading...";
              api
                .request(txtType, {idNo, medium})
                .then(response => {
                  let data = response.data;
                  if (data.status === "00") {
                    let message = "Please check your phone for the new password.";
                    if (this.medium === 'email') {
                      message = "Please check your email for the new password."
                    }
                    helper
                      .successAlert(message)
                      .then(() => {
                        this.$router.push("/");
                      });
                  } else {
                    this.loading = "Request";
                    helper.errorAlert(data.message);
                  }
                })
                .catch(error => {
                  this.loading = "Request";
                  helper.errorAlert(
                    "Sorry, We are unable to send request at this time. Please try again later"
                  );
                  console.log(error);
                });
            }
          })
          .catch(() => {
            console.log("Validation failed");
          });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue